<template>
    <div class="field-mask" ref="shell">
        <div class="field-mask-mask" ref="mask">
            <i class="fas fa-exclamation-triangle"></i>
            <p>Access to certain vital health personnel information is protected under HIPAA.</p>
            <p>By continuing, you agree to adhere to the privacy contained therein.</p>
            <button type="button" class="uk-button uk-button-primary" @click="clearIt">I agree</button>
        </div>
        <div class="field-mask-fields" ref="fields">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FieldMask",

        components: {},

        data() {
            return {};
        },

        mounted() {

        },

        methods: {
            calcHeight(){

            },
            clearIt(){
                this.$refs.shell.classList.add("clear");
            }
        }
    }
</script>
